module.exports = {"320412001":"戚墅堰街道","320412002":"丁堰街道","320412003":"潞城街道","320412100":"湖塘镇","320412102":"牛塘镇","320412103":"洛阳镇","320412104":"遥观镇","320412105":"横林镇","320412106":"横山桥镇","320412110":"雪堰镇","320412113":"前黄镇","320412114":"礼嘉镇","320412119":"嘉泽镇","320412120":"湟里镇","320412400":"武进经济开发区","320412411":"高新区","320412412":"西太湖生态休闲区","320412413":"太湖旅游度假区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320412.json
// module id = 960
// module chunks = 0